/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Settings_Fields_Crisp_Website_IdInputs */

const en_admin_settings_fields_crisp_website_id = /** @type {(inputs: Admin_Settings_Fields_Crisp_Website_IdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Website ID`)
};

/**
* | output |
* | --- |
* | "Website ID" |
*
* @param {Admin_Settings_Fields_Crisp_Website_IdInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const admin_settings_fields_crisp_website_id = /** @type {((inputs?: Admin_Settings_Fields_Crisp_Website_IdInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Settings_Fields_Crisp_Website_IdInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_admin_settings_fields_crisp_website_id(inputs)
});
export { admin_settings_fields_crisp_website_id as "admin.settings.fields.crisp_website_id" }